import { BrowserViewportFactory } from 'pf-frontend-common/src/module/browser/viewport.factory';
import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { StatsAttributionService } from 'pf-frontend-common/src/service/stats-attribution/service';
import { StatsDataService } from 'pf-frontend-common/src/service/stats-data/service';
import { WindowService } from 'pf-frontend-common/src/service/window/service';

import { BrokerStatsDataAdapterFactory } from 'common/data/broker/stats/data-adapter.factory';
import { BrokerSerpStore } from 'common/module/broker-serp/store';
import { BrokerStoreService } from 'common/service/broker-store/service';
import { StatsService } from 'common/service/stats/service';
import { BrokerListViewStore } from 'desktop/module/broker/list/view-store';

// TODO-FE[WEB-1602]: Refactor this to work with common BrokerListViewStore
export function BrokerListViewStoreFactory(brokerSerpStore: BrokerSerpStore): BrokerListViewStore {
  return new BrokerListViewStore(
    EventEmitterFactory(),
    WindowService(),
    BrowserViewportFactory(),
    StatsService(),
    StatsDataService(),
    StatsAttributionService(),
    BrokerStoreService(),
    brokerSerpStore,
    BrokerStatsDataAdapterFactory()
  );
}
